<sd-tab-bar-item-legacy
  icon="CATALOG"
  [isActive]="isActive$ | async"
  (click)="toggleCatalog()"
></sd-tab-bar-item-legacy>
